<app-header [headerState]="AppHeaderStates.customer"></app-header>
<main>
  <!-- <app-home></app-home> -->
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
